import React from 'react';
import { string, func, oneOf } from 'prop-types';
import classnames from 'classnames';
import { renderLinks } from '../../common';

import styles from './HotspotD.css';
import txtStyles from './text-styles.css';

const HotspotD = ({ highlighted, title, description, link, onClick, imageUrl, colorScheme }) => {
  const links = [
    {
      colorScheme,
      onClick,
      class: styles.link,
      text: link,
      icon: { direction: 'right', name: 'link-arrow-right', type: '30' },
      size: 'xl',
      minWidth: 1367
    },
    {
      colorScheme,
      onClick,
      class: styles.link,
      text: link,
      icon: { direction: 'right', name: 'arrow-right', type: '20' },
      size: 'l',
      minWidth: 769,
      maxWidth: 1366
    },
    {
      colorScheme,
      onClick,
      class: styles.link,
      text: link,
      icon: { direction: 'right', name: 'link-arrow-right-17', type: 'other' },
      size: 's',
      maxWidth: 768
    }
  ];

  return (
    <div className={classnames(colorScheme, styles.wrapper)}>
      <div className={styles.container}>
        <h1 className={classnames(txtStyles.title, styles.title)}>
          {highlighted && <span className={styles.highlight}>{highlighted}</span>} {title}
        </h1>

        {
          description &&
            <p className={classnames(txtStyles.description, styles.description)}>{description}</p>
        }

        { renderLinks(links) }

        <div className={styles.image} style={{ backgroundImage: `url(${imageUrl})` }} />
      </div>
    </div>
  );
};

HotspotD.propTypes = {
  highlighted: string,
  title: string.isRequired,
  imageUrl: string,
  description: string,
  link: string.isRequired,
  onClick: func,
  colorScheme: oneOf([
    'lb01',
    'lb02',
    'lb03',
    'lb04',
    'lb05',
    'lb06',
    'lb07',
    'lb08',
    'lb09',
    'lb10'
  ])
};

HotspotD.defaultProps = {
  colorScheme: 'lb01'
};

HotspotD.displayName = 'HotspotD';

export default HotspotD;



// WEBPACK FOOTER //
// ./src/uis/components/Hotspots/Landing/HotspotD/HotspotD.js